import React from "react";

export const PEOPLE_COLUMNS = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    width: 100,
    fixed: "left",
  },
  {
    title: "Role",
    key: "role",
    dataIndex: "role",
    width: 150,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "phone",
    key: "phone",
    title: "Phone",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: 150,
  },
  {
    dataIndex: "email",
    key: "email",
    title: "Email Address",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: 200,
  },
];

export const PEOPLE = [
  {
    name: "Debbie steward",
    role: "Data Steward",
    phone: "9348572564",
    email: "debbie@example.com",
  },
  {
    name: "Don steward",
    role: "Data Steward",
    phone: "9967645789",
    email: "don@example.com",
  },
  {
    name: "Andy steward",
    role: "Application Steward",
    phone: "9785303556",
    email: "andy@example.com",
  },
];
